
import React, { Component } from 'react';
import $, { isXMLDoc } from "jquery";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-datepicker/dist/react-datepicker.css";
import { Line, Pie } from 'react-chartjs-2';
import * as ChartAnnotation from 'chartjs-plugin-annotation';
import { ToastContainer, toast } from 'react-toastify';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import DataTable from "react-data-table-component";

class PatientBreachedRuleDashBoard extends Component {
    constructor(props) {
        super(props);
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const today = new Date();
        this.state = {
            riskFactors: [],
            chartDataArray: [],
            chartThresholdObject: {},
            breachedOptionsData: [],
            breachedIntegerData: [],
            fromDate: props.fromDate ? new Date(props.fromDate) : (localStorage.getItem("startDate") ? new Date(localStorage.getItem("startDate")) : yesterday),
            toDate: props.toDate ? new Date(props.toDate) : (localStorage.getItem("endDate") ? new Date(localStorage.getItem("endDate")) : today),
            isLoading: true,
            noRecords: false,
            medicationGraphData: [],
            integerChartDataArray: [],
            optionsChartDataArray: [],
            isBreachedDataPresent: false,
            showImagePopup: false,
            popupImageUrl: null,
            loadingImage: false,
        };
    }
    componentDidMount() {
        // this.handlePageLoad();
        this.fetchBreachedData();
    }


    handlePageLoad() {
        const breachedDataList = localStorage.getItem("breachedDataList");
        const differenceInDays = localStorage.getItem("differenceInDays");
        if (sessionStorage.getItem('refreshed') === 'true') {
            console.log("Page was refreshed");
            this.fetchBreachedData();
        } else {
            console.log("Page is loading for the first time");
            sessionStorage.setItem('refreshed', 'true');

            if (breachedDataList === "null") {
                this.state.isBreachedDataPresent = false;
                this.state.isLoading = false;
                this.setState(this.state);
            } else if (differenceInDays < 10) {
                this.fetchBreachedData();
            } else {
                this.state.isBreachedDataPresent = true;
                this.setState(this.state);
                this.fetchNotBreachedData();
            }
        }
    }


    groupBySubTargetId = (data, callback) => {
        const groupedIntegers = {};
        const groupedOptions = {};

        data.forEach((current) => {
            const { subTargetId } = current;

            if (current.integerColor) {
                if (!groupedIntegers[subTargetId]) {
                    groupedIntegers[subTargetId] = [];
                }
                groupedIntegers[subTargetId].push(current);
            }
            if (current.optionsColor) {
                if (!groupedOptions[subTargetId]) {
                    groupedOptions[subTargetId] = [];
                }
                groupedOptions[subTargetId].push(current);
            }
        });

        callback({ groupedIntegers, groupedOptions });
    };

    fetchNotBreachedData = () => {

        const breachedDataList = localStorage.getItem("breachedDataList");
        var parsedBreachedData = breachedDataList ? JSON.parse(breachedDataList) : [];

        let setAllToRed = false;

        const groupedByRule = parsedBreachedData.reduce((acc, item) => {
            if (!acc[item.breachedRule]) {
                acc[item.breachedRule] = [];
            }
            acc[item.breachedRule].push(item);
            return acc;
        }, {});

        Object.values(groupedByRule).forEach(group => {
            const dateMap = new Map();

            group.forEach(item => {
                var date;
                var itemLength = Object.entries(item.breachedPoints).length;

                if (itemLength > 0) {
                    date = Object.keys(item.breachedPoints)[0];
                } else {
                    date = Object.keys(item.breachedOptions)[0];
                }

                if (!dateMap.has(date)) {
                    dateMap.set(date, []);
                }

                dateMap.get(date).push(item);
            });

            console.log("Date map", dateMap);

            dateMap.forEach(itemsWithSameDate => {
                const hasRed = itemsWithSameDate.some(
                    item => item.integerColor === "Red" || item.optionsColor === "Red"
                );

                const hasYellow = itemsWithSameDate.some(
                    item => item.integerColor === "Yellow" || item.optionsColor === "Yellow"
                );

                if (hasRed && hasYellow) {
                    itemsWithSameDate.forEach(item => {
                        if (item.integerColor !== null) {
                            item.integerColor = "Yellow";
                        }
                        if (item.optionsColor !== null) {
                            item.optionsColor = "Yellow";
                        }
                    });
                } else if (hasRed) {
                    itemsWithSameDate.forEach(item => {
                        if (item.integerColor !== null) {
                            item.integerColor = "Red";
                        }
                        if (item.optionsColor !== null) {
                            item.optionsColor = "Red";
                        }
                    });
                } else if (hasYellow) {
                    itemsWithSameDate.forEach(item => {
                        if (item.integerColor !== null) {
                            item.integerColor = "Yellow";
                        }
                        if (item.optionsColor !== null) {
                            item.optionsColor = "Yellow";
                        }
                    });
                }
            });
        });


        const modifiedParsedBreachedData = Object.values(groupedByRule).flat();

        console.log("Final modified breached data:", modifiedParsedBreachedData);
        const uniqueRequests = new Set();

        modifiedParsedBreachedData.forEach(item => {
            uniqueRequests.add(JSON.stringify({ targetId: item.targetId, subTargetId: item.subTargetId }));
        });

        const fetchPromises = Array.from(uniqueRequests).map((key) => {
            const { targetId, subTargetId } = JSON.parse(key);
            return this.fetchSingleNotBreachedData(targetId, subTargetId);
        });

        Promise.all(fetchPromises)
            .then((results) => {
                const mergedData = this.mergeData(modifiedParsedBreachedData, results.flat());
                if (mergedData) {
                    console.log("Merged Data::", mergedData);

                    const integerChartDataArray = this.transformGroupedIntegersToChartData(mergedData);
                    const optionsChartDataArray = this.transformGroupedOptionsToChartData(mergedData);

                    if (integerChartDataArray && optionsChartDataArray) {
                        this.updateColorsBasedOnPriority(integerChartDataArray, optionsChartDataArray);
                    }
                }
            })
            .catch((error) => {
                console.error("Error fetching non-breached data:", error);
                this.setState({ isLoading: false });
            });
    };

    fetchSingleNotBreachedData = (targetId, subTargetId) => {
        return new Promise((resolve, reject) => {
            var userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            $.ajax({
                url: "/my-jeeva-api/fetch-not-breached-data",
                method: "GET",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                data: {
                    patientAdmissionId: localStorage.getItem("patientAdmissionId"),
                    journalItemId: subTargetId,
                    journalId: targetId,
                    startDate: this.state.fromDate,
                    endDate: this.state.toDate,
                    userTimeZone: userTimeZone
                },
                success: (res) => {
                    if (res.success) {
                        console.log("Non breached data", res.result);
                        resolve(res.result.length > 0 ? res.result : []);
                    } else {
                        console.error("Request was not successful", res);
                        reject(new Error("Request was not successful"));
                    }
                },
                error: (error) => {
                    console.error("Error fetching risk factors:", error);
                    reject(error);
                }
            });
        });
    };


    updateColorsBasedOnPriority(integerChartDataArray, optionsChartDataArray) {

        const priorityColors = { "Red": 3, "Yellow": 2, "Green": 1 };

        integerChartDataArray = integerChartDataArray.filter(item => Object.keys(item.sumMap).length > 0);
        optionsChartDataArray = optionsChartDataArray.filter(item => Object.keys(item.optionMap).length > 0);

        optionsChartDataArray.forEach(optionsChartData => {
            if (!optionsChartData || typeof optionsChartData.optionMap !== 'object') {
                console.error("Invalid optionMap");
                return;
            }


            Object.keys(optionsChartData.optionMap).forEach(date => {
                const optionColor = optionsChartData.optionMap[date].color;

                integerChartDataArray.forEach(item => {
                    if (item.breachedRule === optionsChartData.breachedRule) {
                        if (item.sumMap[date]) {
                            const sumColor = item.sumMap[date].color;

                            if (priorityColors[optionColor] > priorityColors[sumColor]) {
                                item.sumMap[date].color = optionColor;
                            } else if (priorityColors[sumColor] > priorityColors[optionColor]) {
                                optionsChartData.optionMap[date].color = sumColor;
                            }
                        }
                    }
                });
            });
        });

        integerChartDataArray.forEach(item => {
            Object.keys(item.sumMap).forEach(date => {
                const sumColor = item.sumMap[date].color;

                optionsChartDataArray.forEach(optionsChartData => {
                    if (item.breachedRule === optionsChartData.breachedRule) {
                        if (optionsChartData.optionMap[date]) {
                            const optionColor = optionsChartData.optionMap[date].color;

                            if (priorityColors[sumColor] > priorityColors[optionColor]) {
                                optionsChartData.optionMap[date].color = sumColor;
                            } else if (priorityColors[optionColor] > priorityColors[sumColor]) {
                                item.sumMap[date].color = optionColor;
                            }
                        }
                    }
                });
            });
        });

        integerChartDataArray.forEach(data => {
            let sumMapArray = Object.entries(data.sumMap);

            sumMapArray.sort((a, b) => new Date(a[0]) - new Date(b[0]));

            data.sumMap = Object.fromEntries(sumMapArray);
        });

        // optionsChartDataArray.forEach(data => {
        //     let optionMapArray = Object.entries(data.optionMap);

        //     optionMapArray.sort((a, b) => new Date(a[0]) - new Date(b[0]));

        //     data.optionMap = Object.fromEntries(optionMapArray);
        // });

        optionsChartDataArray.forEach(item => {
            const sortedOptionMap = Object.fromEntries(
                Object.entries(item.optionMap).sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA))
            );
            item.optionMap = sortedOptionMap;
        });


        this.state.integerChartDataArray = integerChartDataArray;
        this.state.optionsChartDataArray = optionsChartDataArray;
        this.state.isLoading = false;
        console.log("integerChartDataArray", integerChartDataArray);
        console.log("optionsChartDataArray", optionsChartDataArray);
        this.setState(this.state);
    }


    mergeData = (parsedBreachedData = [], fetchedData = [], nonBreachedData = []) => {
        const groupedData = {};

        if (Array.isArray(parsedBreachedData)) {
            parsedBreachedData.forEach(item => {
                const subTargetId = item.subTargetId;
                if (!groupedData[subTargetId]) {
                    groupedData[subTargetId] = {
                        integerColor: item.integerColor,
                        optionsColor: item.optionsColor,
                        breachedRule: item.breachedRule,
                        subTargetName: item.subTargetName,
                        patientId: item.patientId,
                        treatmentId: item.treatmentId,
                        targetId: item.targetId,
                        targetName: item.targetName,
                        journalEntryId: item.journalEntryId,
                        breachedPoints: {},
                        breachedOptions: {}
                    };
                }
                if (item.breachedPoints) {
                    Object.entries(item.breachedPoints).forEach(([date, value]) => {

                        if (!groupedData[subTargetId].breachedPoints) {
                            groupedData[subTargetId].breachedPoints = {};
                        }

                        const existingValue = groupedData[subTargetId].breachedPoints[date];

                        const breachedPoint = {
                            value: value,
                            color: item.integerColor,
                        };

                        if (item.isSummationConfigured) {
                            breachedPoint.isSummationConfigured = item.isSummationConfigured;
                        } else {
                            breachedPoint.isSummationConfigured = false;
                        }
                        if (item.timeZone) {
                            breachedPoint.timeZone = item.timeZone
                        } else {
                            breachedPoint.timeZone = null;
                        }

                        groupedData[subTargetId].breachedPoints[date] = breachedPoint;
                    });
                }


                if (item.breachedOptions) {
                    Object.entries(item.breachedOptions).forEach(([date, optionValue]) => {
                        if (!groupedData[subTargetId].breachedOptions) {
                            groupedData[subTargetId].breachedOptions = {};
                        }

                        const existingValue = groupedData[subTargetId].breachedOptions[date];

                        const breachedOptions = {
                            value: optionValue,
                            color: item.optionsColor,
                        };

                        if (!item.isSummationConfigured) {
                            breachedOptions.timeZone = item.timeZone;
                            breachedOptions.isSummationConfigured = item.isSummationConfigured;
                        } else {
                            breachedOptions.timeZone = null;
                            breachedOptions.isSummationConfigured = false
                        }

                        groupedData[subTargetId].breachedOptions[date] = breachedOptions;
                    });
                }

            });
        }
        const uniqueData = fetchedData.filter((item, index, self) =>
            index === self.findIndex((t) => t.journalEntryId === item.journalEntryId)
        );

        if (Array.isArray(fetchedData)) {
            fetchedData.forEach(fetchedItem => {
                const subTargetId = fetchedItem.subTargetId;
                if (!groupedData[subTargetId]) {
                    groupedData[subTargetId] = {
                        integerColor: fetchedItem.integerColor,
                        optionsColor: fetchedItem.optionsColor,
                        breachedRule: fetchedItem.breachedRule,
                        subTargetName: fetchedItem.subTargetName,
                        patientId: fetchedItem.patientId,
                        treatmentId: fetchedItem.treatmentId,
                        targetId: fetchedItem.targetId,
                        targetName: fetchedItem.targetName,
                        breachedPoints: {},
                        breachedOptions: {}
                    };
                }

                if (fetchedItem.isSummationConfigured) {
                    if (fetchedItem.dateEntry) {
                        if (groupedData[subTargetId].integerColor != null) {
                            Object.entries(fetchedItem.dateEntry).forEach(([date, optionValue]) => {
                                if (!groupedData[subTargetId].breachedPoints[date]) {
                                    groupedData[subTargetId].breachedPoints[date] = {
                                        value: optionValue,
                                        color: "Green",
                                        timeZone: null,
                                        isSummationConfigured: fetchedItem.isSummationConfigured

                                    };
                                }
                            });
                        }
                    }
                    if (fetchedItem.dateEntry) {
                        if (groupedData[subTargetId].optionsColor != null) {
                            Object.entries(fetchedItem.dateEntry).forEach(([date, optionValue]) => {
                                if (!groupedData[subTargetId].breachedOptions[date]) {
                                    groupedData[subTargetId].breachedOptions[date] = {
                                        value: optionValue,
                                        color: "Green",
                                        timeZone: null,
                                        isSummationConfigured: fetchedItem.isSummationConfigured
                                    };
                                }
                            });
                        }
                    }
                }
                else {
                    if (groupedData[subTargetId].journalEntryId != fetchedItem.journalEntryId) {
                        if (fetchedItem.dateEntry) {
                            if (groupedData[subTargetId].integerColor != null) {
                                Object.entries(fetchedItem.dateEntry).forEach(([date, optionValue]) => {
                                    if (!groupedData[subTargetId].breachedPoints[date]) {
                                        groupedData[subTargetId].breachedPoints[date] = {
                                            value: optionValue,
                                            color: "Green",
                                            timeZone: fetchedItem.timeZone,
                                            isSummationConfigured: false
                                        };
                                    }
                                });
                            }
                        }
                        if (fetchedItem.dateEntry) {
                            if (groupedData[subTargetId].optionsColor != null) {
                                Object.entries(fetchedItem.dateEntry).forEach(([date, optionValue]) => {
                                    if (!groupedData[subTargetId].breachedOptions[date]) {
                                        groupedData[subTargetId].breachedOptions[date] = {
                                            value: optionValue,
                                            color: "Green",
                                            timeZone: fetchedItem.timeZone,
                                            isSummationConfigured: false
                                        };
                                    }
                                });
                            }
                        }
                    }
                }
            });
        }

        if (groupedData) {
            const transformedData = Object.values(groupedData);

            const groupedByRule = transformedData.reduce((acc, item) => {
                if (!acc[item.breachedRule]) {
                    acc[item.breachedRule] = [];
                }
                acc[item.breachedRule].push(item);
                return acc;
            }, {});

            Object.values(groupedByRule).forEach(group => {
                const dateMap = new Map();

                group.forEach(item => {
                    if (item && typeof item === 'object') {
                        Object.entries(item.breachedPoints || {}).forEach(([date, details]) => {
                            if (!dateMap.has(date)) {
                                dateMap.set(date, []);
                            }
                            dateMap.get(date).push(details);
                        });

                        Object.entries(item.breachedOptions || {}).forEach(([date, details]) => {
                            if (!dateMap.has(date)) {
                                dateMap.set(date, []);
                            }
                            dateMap.get(date).push(details);
                        });
                    }
                });

                dateMap.forEach((itemsWithSameDate, date) => {
                    const hasGreen = itemsWithSameDate.some(
                        detail => detail.color === "Green"
                    );

                    if (hasGreen) {
                        itemsWithSameDate.forEach(detail => {
                            detail.color = "Green";
                        });
                    }
                });
            });

            console.log("Updated Grouped Data", groupedData);
        } else {
            console.error("groupedData is undefined or null");
        }


        if (groupedData) {
            const transformedData = Object.values(groupedData);

            var groupedByRule = transformedData.reduce((acc, item) => {
                if (!acc[item.breachedRule]) {
                    acc[item.breachedRule] = [];
                }
                acc[item.breachedRule].push(item);
                return acc;
            }, {});

            var groupedByTargetId = transformedData.reduce((acc, item) => {
                if (!acc[item.targetId]) {
                    acc[item.targetId] = [];
                }
                acc[item.targetId].push(item);
                return acc;
            }, {});

        }
        const size = Object.keys(groupedByRule).length;


        if (size > 1) {

            const dateColorMap = new Map();

            Object.values(groupedData).forEach(item => {
                Object.entries(item.breachedPoints).forEach(([date, point]) => {
                    if (!dateColorMap.has(date)) {
                        dateColorMap.set(date, []);
                    }
                    dateColorMap.get(date).push(point.color);
                });

                Object.entries(item.breachedOptions).forEach(([date, option]) => {
                    if (!dateColorMap.has(date)) {
                        dateColorMap.set(date, []);
                    }
                    dateColorMap.get(date).push(option.color);
                });
            });

            dateColorMap.forEach((colors, date) => {
                const hasRed = colors.includes("Red");
                const hasYellow = colors.includes("Yellow");

                let finalColor;
                if (hasRed) {
                    finalColor = "Red";
                } if (hasRed && hasYellow) {
                    finalColor = "Red";
                } else if (hasYellow) {
                    finalColor = "Yellow";
                }

                if (finalColor) {
                    Object.values(groupedData).forEach(item => {
                        if (item.breachedPoints[date]) {
                            item.breachedPoints[date].color = finalColor;
                            if (item.integerColor !== null) {
                                item.integerColor = finalColor;
                            }
                        }

                        if (item.breachedOptions[date]) {
                            item.breachedOptions[date].color = finalColor;
                            if (item.optionsColor !== null) {
                                item.optionsColor = finalColor;
                            }
                        }
                    });
                }
            });

            Object.keys(groupedByTargetId).forEach(targetId => {
                const itemsForTargetId = groupedByTargetId[targetId];

                if (itemsForTargetId.length > 1) {
                    const sumConfiguredMap = new Map();
                    const notSumConfiguredMap = new Map();

                    itemsForTargetId.forEach(item => {

                        const breachedPoints = item.breachedPoints;
                        const breachedOptions = item.breachedOptions;

                        if (breachedPoints) {
                            Object.entries(item.breachedPoints).forEach(([datetime, point]) => {
                                const dateKey = this.formatDateString(datetime); // Format date to "YYYY-MM-DD"

                                if (point.isSummationConfigured) {
                                    if (!sumConfiguredMap.has(dateKey)) {
                                        sumConfiguredMap.set(dateKey, []);
                                    }
                                    sumConfiguredMap.get(dateKey).push(point.color, item.targetId)
                                } else {
                                    if (!notSumConfiguredMap.has(dateKey)) {
                                        notSumConfiguredMap.set(dateKey, []);
                                    }
                                    notSumConfiguredMap.get(dateKey).push(point.color, item.targetId);
                                }
                            });
                        }
                        if (breachedOptions) {
                            Object.entries(item.breachedOptions).forEach(([datetime, option]) => {
                                const dateKey = this.formatDateString(datetime); // Format date to "YYYY-MM-DD"

                                if (option.isSummationConfigured) {
                                    if (!sumConfiguredMap.has(dateKey)) {
                                        sumConfiguredMap.set(dateKey, []);
                                    }
                                    sumConfiguredMap.get(dateKey).push(option.color, item.targetId);
                                } else {
                                    if (!notSumConfiguredMap.has(dateKey)) {
                                        notSumConfiguredMap.set(dateKey, []);
                                    }
                                    notSumConfiguredMap.get(dateKey).push(option.color, item.targetId);
                                }
                            });
                        }
                    });


                    if (sumConfiguredMap.size > 0) {
                        sumConfiguredMap.forEach((colors, date) => {
                            const hasRedInSum = colors.includes("Red");
                            const hasYellowInSum = colors.includes("Yellow");

                            const nonSumColors = notSumConfiguredMap.get(date) || [];
                            const hasRedInNonSum = nonSumColors.includes("Red");
                            const hasYellowInNonSum = nonSumColors.includes("Yellow");
                            const hasGreenInNonSum = nonSumColors.includes("Green");

                            if (hasRedInSum) {
                                this.setColorInGroupedData(date, "Red", groupedData, colors[1]);
                            }

                            if (hasRedInNonSum) {
                                this.setColorInGroupedData(date, "Red", groupedData, colors[1]);
                            } else if (hasYellowInSum && !hasRedInNonSum && (hasYellowInNonSum || hasGreenInNonSum)) {
                                this.setColorInGroupedData(date, "Yellow", groupedData, colors[1]);
                            } else if (hasYellowInNonSum && !hasRedInSum) {
                                this.setColorInGroupedData(date, "Yellow", groupedData, colors[1]);
                            }
                        });
                    }
                }
            });

        }


        console.log("Grouped Data", groupedData);
        return Object.values(groupedData);

    };


    setColorInGroupedData(date, color, groupedData, targetId) {
        Object.values(groupedData).forEach(item => {
            var formatItemDate = item;
            if (item.targetId === targetId) {
                if (formatItemDate.breachedPoints) {
                    Object.entries(formatItemDate.breachedPoints).forEach(([datetime]) => {
                        const dateKey = this.formatDateString(datetime);
                        if (date === dateKey) {
                            item.breachedPoints[datetime].color = color;
                            if (item.integerColor !== null) {
                                item.integerColor = color;
                            }
                        }
                    });
                }
                if (formatItemDate.breachedOptions) {
                    Object.entries(formatItemDate.breachedOptions).forEach(([datetime]) => {
                        const dateKey = this.formatDateString(datetime);
                        if (date === dateKey) {
                            item.breachedOptions[datetime].color = color;
                            if (item.optionsColor !== null) {
                                item.optionsColor = color;
                            }
                        }
                    });
                }
            }
        });
    }


    formatDateString(datetime) {
        const date = new Date(datetime);
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }


    transformGroupedIntegersToChartData = (mergedData) => {
        const result = [];

        for (let i = 0; i < mergedData.length; i++) {
            const entry = mergedData[i];

            if (entry.optionsColor === null || entry.optionsColor === undefined) {
                const sumMap = {};
                const targetName = entry.targetName;
                const subTargetName = entry.subTargetName;
                const name = `${targetName}-${subTargetName}`;
                const color = entry.integerColor;
                const breachedRule = entry.breachedRule;


                Object.entries(entry.breachedPoints).forEach(([date, { value, color, timeZone, isSummationConfigured }]) => {
                    if (!sumMap[date]) {
                        sumMap[date] = { value: 0, color, timeZone, isSummationConfigured };
                    }
                    sumMap[date].value += parseFloat(value);
                });

                result.push({ name, sumMap, color, breachedRule });
            }
        }
        return result;
    };

    transformGroupedOptionsToChartData = (mergedData) => {
        const result = [];

        for (let i = 0; i < mergedData.length; i++) {
            const entry = mergedData[i];

            if (entry.integerColor === null || entry.integerColor === undefined) {
                const optionMap = {};
                const targetName = entry.targetName;
                const subTargetName = entry.subTargetName;
                const name = `${targetName}-${subTargetName}`;
                let color = entry.optionsColor;
                const breachedRule = entry.breachedRule;

                Object.entries(entry.breachedOptions).forEach(([date, { value, color, timeZone, isSummationConfigured }]) => {
                    if (!optionMap[date]) {
                        optionMap[date] = { value: "", color, timeZone, isSummationConfigured };
                    }
                    optionMap[date].value += value;
                });

                result.push({ name, optionMap, color, breachedRule });
            }
        }

        return result;
    };


    componentDidUpdate(prevProps) {
        if (prevProps.fromDate !== this.props.fromDate || prevProps.toDate !== this.props.toDate) {
            this.setState({
                isLoading: true,
                fromDate: this.props.fromDate,
                toDate: this.props.toDate,
                riskFactors: [],
                chartThresholdObject: {}
            }, () => {
                this.fetchBreachedData();
            });
        }
    }

    fetchBreachedData() {
        var thisController = this;
        var userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;


        $.ajax({
            url: "/my-jeeva-api/fetch-breached-data",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                patientAdmissionId: localStorage.getItem("patientAdmissionId"),
                startDate: thisController.state.fromDate,
                endDate: thisController.state.toDate,
                timeZone: userTimeZone
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result != null) {
                        thisController.state.isBreachedDataPresent = true;
                        thisController.setState(this.state);
                        var riskJson = res.result[localStorage.getItem("patientAdmissionId")];
                        if (riskJson) {
                            var breachedData = riskJson.breachedDataPointsList;
                            localStorage.setItem("riskLevel", riskJson.riskCategory);
                            if (res.result.breachedRuleSetName) {
                                localStorage.setItem("breachedRuleSetNames", riskJson.breachedRuleSetName);
                            } else {
                                localStorage.setItem("breachedRuleSetNames", riskJson.breachedRuleSetNames);
                            }
                            localStorage.setItem("breachedDataList", JSON.stringify(breachedData));
                            thisController.fetchNotBreachedData();
                        } else {
                            thisController.state.isBreachedDataPresent = false;
                            thisController.state.isLoading = false;
                            localStorage.setItem("breachedRuleSetNames", "-");
                            thisController.setState(thisController.state);
                        }
                    } else {
                        thisController.state.isBreachedDataPresent = false;
                        thisController.state.isLoading = false;
                        localStorage.setItem("breachedRuleSetNames", "-");
                        thisController.setState(thisController.state);
                    }
                } else {
                    // e.g. the admission was deleted - stop loading instead of spinning forever
                    console.error("Breached data request was not successful", res);
                    thisController.setState({ isBreachedDataPresent: false, isLoading: false });
                }
            },
            error: function (error) {
                console.error("Error fetching risk factors:", error);
                thisController.setState({ isBreachedDataPresent: false, isLoading: false });
            }
        });
    }


    fetchBreachedRuleData() {
        var thisController = this;
        var parentRuleIds = localStorage.getItem("parentRuleId").split(',');

        var apiCalls = parentRuleIds.map(function (parentRuleId) {
            return $.ajax({
                url: "/my-jeeva-api/fetch-breached-rule-data",
                method: "GET",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                data: {
                    parentRuleId: parentRuleId.trim(),
                    patientAdmissionId: localStorage.getItem("patientAdmissionId"),
                    startDate: thisController.state.fromDate,
                    endDate: thisController.state.toDate,
                }
            });
        });

        Promise.all(apiCalls)
            .then(function (responses) {
                var integerResults = [];
                var optionResults = [];

                responses.forEach(function (res) {
                    if (Array.isArray(res.result)) {
                        res.result.forEach(rule => {
                            if (rule.highRiskOption === null && rule.mediumRiskOption === null) {
                                const integerData = {
                                    name: `${rule.targetName}-${rule.subTargetName}`,
                                    sumMap: rule.sumMap,
                                    riskRuleName: rule.riskRuleName,
                                    lowThresholdValue: rule.lowThresholdValue,
                                    highThresholdValue: rule.highThresholdValue,
                                    riskFactorName: rule.subTargetName,
                                    comparison: rule.comparison
                                };
                                integerResults.push(integerData);
                            } else {
                                const optionsData = {
                                    name: `${rule.targetName}-${rule.subTargetName}`,
                                    journalName: rule.targetName,
                                    riskFactorName: rule.subTargetName,
                                    optionMap: rule.optionMap,
                                    riskRuleName: rule.riskRuleName,
                                    mediumRiskOption: rule.mediumRiskOption,
                                    highRiskOption: rule.highRiskOption
                                };
                                optionResults.push(optionsData);
                            }
                        });
                    }
                });

                thisController.setState({ breachedIntegerData: integerResults, breachedOptionsData: optionResults, isLoading: false });
                console.log("Breached Integer Data", thisController.state.breachedIntegerData);
                console.log("Breached Options Data", thisController.state.breachedOptionsData);

                if (optionResults.length === 0 && integerResults.length === 0) {
                    thisController.setState({ noRecords: true });
                }
                thisController.fetchRiskFactors();
            })
            .catch(function (error) {
                console.error("Error fetching risk factors:", error);
                thisController.setState({ isLoading: false });
            });
    }



    fetchRiskData(journalId, riskFactor, callback) {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/fetch-risk-data",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                riskFactor: riskFactor,
                journalId: journalId,
                patientAdmissionId: localStorage.getItem("patientAdmissionId"),
                startDate: thisController.state.fromDate,
                endDate: thisController.state.toDate,
            },
            success: function (res) {
                if (res.success === true) {
                    thisController.updateChartData(res.result, riskFactor, journalId, callback);

                }
            },
            error: function (error) {
                console.error("Error fetching risk data for risk factor", riskFactor, ":", error);
                if (typeof callback === 'function') {
                    callback();
                }
            }
        });
    }

    updateChartData(data, riskFactor, journalId, callback) {

        const sortedDates = Object.keys(data).sort((a, b) => new Date(a) - new Date(b));
        const dates = sortedDates.map(date => this.formatDate(date));
        const values = sortedDates.map(date => data[date]);

        if (dates && values) {
            const chartData = {
                labels: dates,
                datasets: [{
                    label: riskFactor,
                    data: values,
                    fill: false,
                    borderColor: 'rgb(75, 192, 192)',
                    tension: 0.1,
                }]
            };



            if (this.state.breachedIntegerData) {

            }

            this.journalAndRiskFactorMerge(journalId, riskFactor, chartData, callback);
        } else {
            if (callback) callback();
        }
    }

    journalAndRiskFactorMerge(journalId, riskFactor, chartData, callback) {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/get-journal-name",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                journalId: journalId,
            },
            success: function (res) {
                if (res.success === true) {
                    var mergedName = res.result.title + " -- " + riskFactor;
                    thisController.setState(prevState => ({
                        isLoading: false,
                        riskFactors: [...prevState.riskFactors, mergedName],
                        chartDataArray: [...prevState.chartDataArray, chartData],

                    }));
                    // thisController.fetchMedicationGraphData();
                }
                if (callback) callback();
            },
            error: function (error) {
                console.error("Error merging journal name and risk factor:", error);
                if (callback) callback();
            }
        });
    }

    fetchMedicationGraphData() {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/fetch-medication-adherence",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                patientId: localStorage.getItem("patientId"),
                treatmentId: localStorage.getItem("treatmentIdForDashBoard"),
                startDate: thisController.state.fromDate,
                endDate: thisController.state.toDate
            },
            success: function (res) {
                if (res.success === true) {
                    thisController.state.medicationGraphData = res.result;
                    thisController.setState(thisController.state);
                }
            },
            error: function (error) {
                console.error("Error fetching medication data:", error);
            }
        });
    }

    handleFromDateChange = (date) => {
        const { toDate } = this.state;
        if (date < toDate) {
            localStorage.setItem("startDate", date);
            localStorage.setItem("endDate", this.state.toDate);
            this.setState({
                isLoading: true,
                fromDate: date,
                riskFactors: [],
                chartDataArray: [],
                chartThresholdObject: {}
            }, () => this.fetchBreachedData());
        } else {
            this.notifyImproperDateSelection("from");
        }
    };

    handleToDateChange = (date) => {
        const { fromDate } = this.state;
        const today = new Date();
        if (date > fromDate && (date <= today)) {
            localStorage.setItem("startDate", this.state.fromDate);
            localStorage.setItem("endDate", date);
            this.setState({
                isLoading: true,
                toDate: date,
                riskFactors: [],
                chartDataArray: [],
                chartThresholdObject: {}
            }, () => this.fetchBreachedData);
        } else if (date < fromDate) {
            this.notifyImproperDateSelection("to");
        } else if (date > today) {
            this.notifyImproperToDateSelection();
        }
    };



    notifyImproperDateSelection(message) {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                />
                &nbsp;&nbsp;{message === "from" ? "From date should be less than To Date." : "To date should be greater than From Date."}
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyImproperToDateSelection() {

        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                />
                &nbsp;&nbsp; To date cannot be greater than today's date.
            </b>,
            {
                position: "top-center",
            }
        );
    }


    formatDate(dateString, timeZone, isSummationConfigured) {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const date = new Date(dateString);

        const year = date.getFullYear();
        const month = months[date.getMonth()];
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        if (isSummationConfigured) {
            return `${year}-${month}-${day}`;
        }
        if (hours == "00" && minutes == "00") {
            return `${year}-${month}-${day}`;
        } else {
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        }

    }


    backToRiskBoard = () => {
        localStorage.setItem("startDate", this.state.fromDate);
        localStorage.setItem("endDate", this.state.toDate);
        sessionStorage.removeItem('refreshed');
        this.props.history.push({
            pathname: "/projectmgmt/reports"
        })
    }

    getPieData = (medication) => ({
        labels: ['Taken', 'Not Taken'],
        datasets: [
            {
                data: [medication.percentageTaken, medication.percentageNotTaken],
                backgroundColor: ['lightgreen', 'red'],
                hoverBackgroundColor: ['#36A2EB', '#FF6384']
            }
        ]
    });

    caseInsensitiveSort = (field) => (rowA, rowB) => {

        const a = rowA[field] ? rowA[field].toLowerCase() : '';
        const b = rowB[field] ? rowB[field].toLowerCase() : '';

        if (a > b) {
            return 1;
        }
        if (b > a) {
            return -1;
        }
        return 0;
    };

    getColumns() {
        const columns = [
            {
                name: <b style={{ fontSize: "16px" }}>Rule Name</b>,
                sortable: true,
                selector: (row) => (
                    <div
                        className="textarea"
                        style={{
                            background: "white",
                            height: "2.7em",
                            resize: "none",
                            paddingLeft: "2px",
                            paddingTop: "6px",
                            width: "100%",
                            border: "none",
                            overflow: "hidden",
                        }}
                    >
                        {row.riskRuleName}
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>High Risk Option</b>,
                sortable: true,
                selector: (row) => (
                    <div
                        className="textarea"
                        style={{
                            background: "white",
                            height: "2.7em",
                            resize: "none",
                            paddingLeft: "2px",
                            paddingTop: "6px",
                            width: "100%",
                            border: "none",
                            overflow: "hidden",
                        }}
                    >
                        {row.highRiskOption}
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Medium Risk Option</b>,
                sortable: true,
                selector: (row) => (
                    <div
                        className="textarea"
                        style={{
                            background: "white",
                            height: "2.7em",
                            resize: "none",
                            paddingLeft: "2px",
                            paddingTop: "6px",
                            width: "100%",
                            border: "none",
                            overflow: "hidden",
                        }}
                    >
                        {row.mediumRiskOption}
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Entries</b>,
                sortable: true,
                selector: (row) => (
                    <div style={{ overflow: "scroll" }}>
                        {row.optionMap ? (
                            Object.entries(row.optionMap).map(([key, value]) => (
                                <div key={key}>
                                    {this.formatDate(key)}: {value}
                                </div>
                            ))
                        ) : (
                            <div>No data</div>
                        )}
                    </div>
                ),
            },
        ];

        return columns;
    }

    isUUID(value) {
        const uuidRegex =
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
        return uuidRegex.test(value.trim());
    }

    openImagePopup = (url) => {
        this.setState({
            showImagePopup: true,
            popupImageUrl: null,
            loadingImage: true,
        });

        const img = new Image();
        img.src = url;

        img.onload = () => {
            this.setState({
                popupImageUrl: url,
                loadingImage: false,
            });
        };

        img.onerror = () => {
            this.setState({ loadingImage: false });
            alert("Failed to load image. Please try again.");
        };
    };

    closeImagePopup = () => {
        this.setState({
            showImagePopup: false,
            popupImageUrl: null,
        });
    };

    getChartOptions() {
        return {
            maintainAspectRatio: false,
            animation: { duration: 0 },
            hover: {
                mode: 'index',        // changed from 'nearest'
                intersect: false,     // keeps tooltip active even slightly off point
                animationDuration: 0
            },
            tooltips: {
                enabled: true,
                mode: 'index',        // changed from 'nearest'
                intersect: false,     // ← this is the key fix
            },
            elements: {
                point: {
                    hitRadius: 20,    // increased hit area
                    hoverRadius: 8,
                    radius: 5
                }
            },
            annotation: {
                drawTime: 'afterDatasetsDraw',
                events: [],
                annotations: [
                    {
                        type: 'line',
                        mode: 'horizontal',
                        scaleID: 'y-axis-0',
                        borderColor: 'red',
                        borderWidth: 4,
                    },
                    {
                        type: 'line',
                        mode: 'horizontal',
                        scaleID: 'y-axis-0',
                        borderColor: 'yellow',
                        borderWidth: 4,
                    }
                ]
            }
        };
    }

    render() {
        const { breachedIntegerData, riskFactors, optionsChartDataArray, integerChartDataArray } = this.state;



        return (
            <div>
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                <link rel="stylesheet" href="assets/css/adminlte.css" />
                <link rel="stylesheet" href="assets/css/custom-style.css" />
                <link rel="stylesheet" href="assets/css/styles.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <link rel="stylesheet" href="assets/css/DashBoardGraph.css" />

                <div>
                    <div className="card">
                        {this.state.isLoading && (
                            <div style={{ padding: '20px', textAlign: 'center' }}>
                                <p>Loading ...</p>
                            </div>
                        )}
                        {!this.state.isLoading && !this.state.isBreachedDataPresent && (
                            <div style={{ padding: '20px', textAlign: 'center' }}>
                                <p>There are no breached data present to display.</p>
                            </div>
                        )}
                    </div>

                    {!this.state.isLoading && this.state.isBreachedDataPresent && (
                        <div className="graph-container">
                            {integerChartDataArray.length > 0 && (
                                integerChartDataArray.map((data, index) => {
                                    const labels = Object.keys(data.sumMap).map(dateString => {
                                        const sumMapEntry = data.sumMap[dateString];
                                        const timeZone = sumMapEntry.timeZone;
                                        const isSummationConfigured = sumMapEntry.isSummationConfigured;
                                        return this.formatDate(dateString, timeZone, isSummationConfigured);
                                    });
                                    const values = Object.values(data.sumMap).map(point => point.value);
                                    const colors = Object.values(data.sumMap).map(point => point.color);

                                    const radii = colors.map(color => {
                                        if (color === "Red") return 7;
                                        if (color === "Yellow") return 5;
                                        return 3;
                                    });

                                    const chartData = {
                                        labels: labels,
                                        datasets: [{
                                            label: data.name,
                                            data: values,
                                            fill: false,
                                            pointBackgroundColor: colors,
                                            pointBorderColor: 'black',
                                            pointRadius: radii,          
                                            pointHitRadius: 20,          
                                            pointHoverRadius: 10,
                                            borderColor: 'rgba(75,192,192,1)',
                                            tension: 0.1,
                                        }],
                                    };

                                    return (
                                        <div key={index} className="graph-box">
                                            <div style={{ fontSize: "15px", whiteSpace: 'nowrap', display: "flex", justifyContent: "center", textDecoration: "underline", marginBottom: "2vh", fontWeight: "bold" }}>
                                                {data.name}
                                            </div>
                                            <Line data={chartData}
                                                // plugins={[ChartAnnotation]}
                                                options={this.getChartOptions()}
                                            />
                                        </div>
                                    );
                                })
                            )}


                            {optionsChartDataArray.length > 0 &&
                                optionsChartDataArray.map((data) => (
                                    <div className="graph-box" key={data.id}>
                                        <div style={{
                                            fontSize: "15px",
                                            whiteSpace: 'nowrap',
                                            display: "flex",
                                            justifyContent: "center",
                                            textDecoration: "underline",
                                            marginBottom: "4.5vh",
                                            fontWeight: "bold"
                                        }}>
                                            {data.name}
                                        </div>
                                        {data.optionMap && typeof data.optionMap === 'object' && (
                                            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                <DataTable
                                                    className="data-table-border"
                                                    data={Object.entries(data.optionMap).map(([date, { value, color }]) => ({
                                                        date: this.formatDate(date, data.timeZone, ""),
                                                        value,
                                                        color,
                                                    }))}
                                                    columns={[
                                                        {
                                                            name: 'Date and Time',
                                                            selector: 'date',
                                                            sortable: true,
                                                        },
                                                        {
                                                            name: 'Entries',
                                                            selector: 'value',
                                                            sortable: true,
                                                            cell: row => {
                                                                return (
                                                                    <div style={{
                                                                        padding: '5px',
                                                                        borderRadius: '4px'
                                                                    }}>
                                                                        {this.isUUID(row.value.trim()) ? (
                                                                            <img
                                                                                src={`/my-jeeva-api/fetch-media-by-id?mediaId=${row.value.trim()}`}
                                                                                style={{ width: "80px", height: "80px", borderRadius: "6px" }}
                                                                                alt="media"
                                                                                onClick={() => this.openImagePopup(`/my-jeeva-api/fetch-media-by-id?mediaId=${row.value.trim()}`)}

                                                                            />
                                                                        ) : (
                                                                            <span>{row.value.trim()}</span>
                                                                        )}
                                                                    </div>
                                                                );
                                                            }
                                                        },
                                                        {
                                                            name: 'Risk Type',
                                                            sortable: true,
                                                            sortFunction: this.caseInsensitiveSort('color'),
                                                            cell: row => {
                                                                const backgroundColor = row.color;
                                                                return (
                                                                    <div style={{
                                                                        padding: '5px'
                                                                    }}>
                                                                        {backgroundColor === "Red" && <img
                                                                            src="/my-jeeva/assets/images/high-risk-96.png"
                                                                            style={{ paddingRight: "0px", height: "40px", width: "40px" }}
                                                                            content=""
                                                                        />}
                                                                        {backgroundColor === "Yellow" && <img
                                                                            src="/my-jeeva/assets/images/warning-96.png"
                                                                            style={{ paddingRight: "0px", height: "40px", width: "40px" }}
                                                                            content=""
                                                                        />}
                                                                    </div>
                                                                );
                                                            }
                                                        },
                                                    ]}
                                                />
                                                {this.state.showImagePopup && (
                                                    <div
                                                        style={{
                                                            position: "fixed",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100vw",
                                                            height: "100vh",
                                                            backgroundColor: "rgba(0, 0, 0, 0.75)",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            zIndex: 9999,
                                                        }}
                                                        onClick={this.closeImagePopup}
                                                    >
                                                        <div
                                                            style={{
                                                                position: "relative",
                                                                background: "white",
                                                                padding: "10px",
                                                                borderRadius: "10px",
                                                                maxWidth: "90%",
                                                                maxHeight: "90%",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                            onClick={(e) => e.stopPropagation()} // Prevent popup close when clicking inside
                                                        >
                                                            {/* Show loader while image is loading */}
                                                            {this.state.loadingImage ? (
                                                                <div style={{ color: "#333", fontSize: "16px" }}>Loading image...</div>
                                                            ) : (
                                                                <div>
                                                                    {/* Show close button only after image is loaded */}
                                                                    <button
                                                                        onClick={this.closeImagePopup}
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "5px",
                                                                            right: "10px",
                                                                            background: "rgba(0,0,0,0.6)",
                                                                            color: "white",
                                                                            border: "none",
                                                                            borderRadius: "50%",
                                                                            width: "28px",
                                                                            height: "28px",
                                                                            cursor: "pointer",
                                                                            fontSize: "18px",
                                                                        }}
                                                                    >
                                                                        ×
                                                                    </button>

                                                                    <img
                                                                        src={this.state.popupImageUrl}
                                                                        alt="Preview"
                                                                        style={{
                                                                            maxWidth: "90vw",
                                                                            maxHeight: "90vh",
                                                                            objectFit: "contain",
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                    </div>
                                ))
                            }
                        </div>
                    )}
                </div>
                <ToastContainer className="Toast-at-center" />
            </div>
        );
    }

}

export default PatientBreachedRuleDashBoard;





// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/PatientBreachedRuleDashBoard.js